module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921115651_T.735a31c6.jpg";